import React, { Suspense, useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
import { PageLoader } from '../PageLoader';
import { allNavItems } from '../../data/navigation';
import { useDocumentMeta } from '../../hooks/useDocumentMeta';
import { PageSourcesProvider } from '../../contexts/PageSourcesContext';
function labelFor(pathname: string): string | null {
  if (pathname === '/') return null;
  if (pathname.startsWith('/frontier-7sigma')) return 'Deck 7σ';
  if (/^\/countries\/.+/.test(pathname)) return 'Country record';
  return allNavItems.find(i => i.to !== '/' && pathname.startsWith(i.to))?.label ?? 'Not found';
}
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useDocumentMeta(labelFor(pathname), pathname);
  useEffect(() => {
    if (hash) {
      const t = window.setTimeout(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({
          block: 'start'
        });
      }, 60);
      return () => window.clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  const showSources = !pathname.startsWith('/frontier-7sigma');
  return <div className="flex min-h-screen w-full flex-col bg-bg text-ink" data-id="element-380" data-mp="38cficszcnfbp">
      <SiteHeader data-id="element-381" data-mp="9u9yxaq3jnfz" />
      <PageSourcesProvider slot={slot} data-id="element-382" data-mp="9utj6y37ynx6">
        <main className="flex-1" data-id="element-383" data-mp="9trvnu50o8yk">
          <Suspense fallback={<PageLoader data-id="element-385" data-mp="4unmv4m08d8r" />} data-id="element-384" data-mp="4v75yone57od">
            <Outlet data-id="element-386" data-mp="4wi8ym90ibef" />
          </Suspense>
        </main>
      </PageSourcesProvider>
      {showSources && <section aria-labelledby="page-sources-title" className="mx-auto mt-16 w-full max-w-[1400px] px-5 md:px-8 [&:has(.ps-slot:empty)]:hidden" data-id="element-387" data-mp="3vzx52a3rbn7t">
          <div className="flex flex-col gap-3 border-t border-line pt-6 md:flex-row md:items-start md:justify-between" data-id="element-388" data-mp="2kmbecki91dk6">
            <div className="md:w-56" data-id="element-389" data-mp="2fmyvsbyeusne">
              <h2 id="page-sources-title" className="text-[13px] font-medium text-ink" data-id="element-390" data-mp="2flx7h5sdw9nq">
                Sources for this page
              </h2>
              <Link to="/methodology#sources" className="mt-1 inline-block text-[12px] text-muted underline decoration-line underline-offset-2 hover:text-machine" data-id="element-391" data-mp="1bp4m1hh33imh">
                Full numbered source index →
              </Link>
            </div>
            <div ref={setSlot} className="ps-slot flex flex-1 flex-col gap-2 md:items-end" data-id="element-392" data-mp="12n55eq9zegk2" />
          </div>
        </section>}
      <SiteFooter data-id="element-393" data-mp="nxzahei6fchz" />
    </div>;
}